import React from 'react';

type Props = {
  className?: string;
};

export const AboutBanner: React.FC<Props> = ({ className }) => {
  return (
    <>
      <div className={`text-center ${className}`}>
        <h2 className="text-4xl tracking-tight font-bold  sm:text-3xl md:text-5xl">
          <span className="block text-gray-900">About Us</span>
        </h2>
        <p className="px-0 mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
          We serve those committed to serving others.
        </p>
      </div>
    </>
  );
};
